module.exports = __webpack_public_path__ + "img/Singrunde.eaff5ae0.jpg";